/* eslint-disable no-unused-vars */

import React, { useState, useEffect } from 'react';

import style from './style.module.scss';

const DisabledLocation = ({ className, text, showLocationDisabledInfo }) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    if (showLocationDisabledInfo) {
      setIsVisible(true);
    } else {
      const timer = setTimeout(() => setIsVisible(false), 1000);
      return () => clearTimeout(timer);
    }
  }, [showLocationDisabledInfo]);

  return (
    <div
      className={`${style.toast} ${className || ''} ${
        showLocationDisabledInfo ? style.showToast : style.closedToast
      } ${!isVisible ? style.hidden : ''}`}
    >
      <p>{text}</p>
    </div>
  );
};

export default DisabledLocation;
